import React from 'react';
import PropTypes from 'prop-types';
import { GeoJSONLayer } from '@geo/react-grabmaps-gl';

export const ROUTE_COLOR = {
  GREEN: '#00B14F',
  GREY: '#9FA4AD',
};

const RouteLayer = ({ steps, color, width }) => {
  /**
   * @type {import('@geo/react-grabmaps-gl/lib/geojson-layer').Props['data']}
   */
  const geoData = {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: steps,
    },
  };

  const linePaint = {
    'line-color': color,
    'line-width': width,
  };

  const lineLayout = {
    'line-cap': 'round',
    'line-join': 'round',
  };

  return (
    <GeoJSONLayer
      data={geoData}
      linePaint={linePaint}
      lineLayout={lineLayout}
    />
  );
};

RouteLayer.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)).isRequired,
  width: PropTypes.number,
  color: PropTypes.string,
};

RouteLayer.defaultProps = {
  width: 1,
  color: ROUTE_COLOR.GREEN,
};

export default RouteLayer;
